const PIXEL_ID = '240885986826920';
const EVENTS = new Set(['FinSimulation', 'EtreRappele', 'FinFormInline', 'FinFormModal']);
let hasConsent = false;

// GTM owns the pixel loader. Axeptio replays saved choices to late subscribers,
// including when this module is loaded with the lazy callback form.
try {
  window._axcb = window._axcb || [];
  window._axcb.push((sdk) => {
    sdk.on('cookies:complete', (choices) => {
      hasConsent = choices?.facebook_pixel === true;
    });
  });
} catch {
  // An unavailable CMP must not prevent a form from being submitted.
}

export function trackMetaEvent(event) {
  if (
    window.metaTrackingEnabled !== true ||
    !hasConsent ||
    !EVENTS.has(event) ||
    typeof window.fbq !== 'function'
  ) {
    return;
  }

  try {
    // No personal data, no second pixel initialization and no deferred replay.
    window.fbq('trackSingleCustom', PIXEL_ID, event);
  } catch {
    // Tracking failures must not turn a successful submission into a form error.
  }
}

export function trackCallRequestConversion({ provider, offer, inline }) {
  if (provider && provider !== 'COZY') return;

  const event = offer ? (inline ? 'FinFormInline' : 'FinFormModal') : 'EtreRappele';
  trackMetaEvent(event);
}
